// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__6br4w","alertIcon":"ConfirmModal_alertIcon__2J5Pg"};